(() => {
  const API_URL =
    'https://vinarkivet-ai-backend.vercel.app/api/chat';

  const initVinarkivetAI = (root) => {
    if (
      !root ||
      root.dataset.vaInitialized === 'true'
    ) {
      return;
    }

    root.dataset.vaInitialized = 'true';

    const messagesContainer = root.querySelector(
      '[data-va-messages]'
    );

    const form = root.querySelector(
      '[data-va-form]'
    );

    const input = root.querySelector(
      '[data-va-input]'
    );

    const newChatButton = root.querySelector(
      '[data-va-new-chat]'
    );

    const sendButton = form?.querySelector(
      '.va-ai__send'
    );

    if (
      !messagesContainer ||
      !form ||
      !input
    ) {
      return;
    }

    const originalContent =
      messagesContainer.innerHTML;

    let conversationHistory = [];
    let isReplying = false;

    const getShopifyRoot = () => {
      const rootPath =
        window.Shopify?.routes?.root;

      if (
        typeof rootPath === 'string' &&
        rootPath
      ) {
        return rootPath;
      }

      return '/';
    };

    const scrollToBottom = () => {
      messagesContainer.scrollTo({
        top: messagesContainer.scrollHeight,
        behavior: 'smooth'
      });
    };

    const resizeInput = () => {
      input.style.height = 'auto';

      input.style.height = `${Math.min(
        input.scrollHeight,
        160
      )}px`;
    };

    const createMessage = (
      role,
      text
    ) => {
      const article =
        document.createElement('article');

      article.className = [
        'va-ai__message',
        role === 'user'
          ? 'va-ai__message--user'
          : 'va-ai__message--assistant'
      ].join(' ');

      const avatar =
        document.createElement('div');

      avatar.className =
        'va-ai__avatar';

      avatar.setAttribute(
        'aria-hidden',
        'true'
      );

      avatar.textContent =
        role === 'user'
          ? 'D'
          : 'V';

      const content =
        document.createElement('div');

      content.className =
        'va-ai__message-content';

      const name =
        document.createElement('div');

      name.className =
        'va-ai__message-name';

      name.textContent =
        role === 'user'
          ? 'Dig'
          : 'Vinarkivets Sommelier';

      const bubble =
        document.createElement('div');

      bubble.className =
        'va-ai__bubble';

      const paragraphs = String(text)
        .split('\n')
        .map((paragraph) => {
          return paragraph.trim();
        })
        .filter(Boolean);

      paragraphs.forEach(
        (paragraphText) => {
          const paragraph =
            document.createElement('p');

          paragraph.textContent =
            paragraphText;

          bubble.appendChild(
            paragraph
          );
        }
      );

      content.appendChild(name);
      content.appendChild(bubble);

      article.appendChild(avatar);
      article.appendChild(content);

      messagesContainer.appendChild(
        article
      );

      scrollToBottom();

      return article;
    };

    const createTypingIndicator = () => {
      const article = createMessage(
        'assistant',
        'Sommelieren tænker...'
      );

      article.classList.add(
        'va-ai__message--typing'
      );

      return article;
    };

    const hideSuggestions = () => {
      const suggestions =
        messagesContainer.querySelector(
          '[data-va-suggestions]'
        );

      if (suggestions) {
        suggestions.hidden = true;
      }
    };

    const getNumericVariantId = (
      variantId
    ) => {
      const value =
        String(variantId || '').trim();

      if (!value) {
        return null;
      }

      const lastPart =
        value.split('/').pop();

      if (!/^\d+$/.test(lastPart)) {
        return null;
      }

      return Number(lastPart);
    };

    const updateVisibleCartCounts = (
      cart
    ) => {
      const count =
        Number(cart?.item_count) || 0;

      const selectors = [
        '[data-cart-count]',
        '[data-header-cart-count]',
        '[data-cart-count-bubble]',
        '.cart-count',
        '.cart-count-bubble span[aria-hidden="true"]'
      ];

      document
        .querySelectorAll(
          selectors.join(',')
        )
        .forEach((element) => {
          element.textContent =
            String(count);

          element.hidden =
            count === 0;
        });
    };

    const notifyThemeAboutCart = (
      cart,
      addedProduct
    ) => {
      const detail = {
        cart,
        product: addedProduct
      };

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            bubbles: true,
            detail
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail
          }
        )
      );

      window.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail
          }
        )
      );
    };

    const createCartStatus = (
      statusElement
    ) => {
      statusElement.replaceChildren();

      const text =
        document.createElement('span');

      text.textContent =
        'Vinen er lagt i kurven. ';

      const cartLink =
        document.createElement('a');

      cartLink.href =
        `${getShopifyRoot()}cart`;

      cartLink.textContent =
        'Se kurven';

      statusElement.appendChild(text);
      statusElement.appendChild(
        cartLink
      );
    };

    const addProductToCart = async (
      product,
      button,
      statusElement
    ) => {
      const variantId =
        getNumericVariantId(
          product?.variantId
        );

      if (!variantId) {
        statusElement.textContent =
          'Denne vin kunne ikke lægges i kurven. Åbn produktsiden og vælg variant.';

        return;
      }

      const originalButtonText =
        button.textContent;

      button.disabled = true;
      button.textContent =
        'Tilføjer...';

      statusElement.textContent = '';

      try {
        const addResponse = await fetch(
          `${getShopifyRoot()}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          }
        );

        let addData = null;

        try {
          addData =
            await addResponse.json();
        } catch (error) {
          addData = null;
        }

        if (!addResponse.ok) {
          throw new Error(
            addData?.description ||
            addData?.message ||
            'Produktet kunne ikke lægges i kurven.'
          );
        }

        const cartResponse =
          await fetch(
            `${getShopifyRoot()}cart.js`,
            {
              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        let cart = null;

        if (cartResponse.ok) {
          cart =
            await cartResponse.json();

          updateVisibleCartCounts(
            cart
          );
        }

        notifyThemeAboutCart(
          cart,
          product
        );

        button.textContent =
          'Tilføjet ✓';

        createCartStatus(
          statusElement
        );
      } catch (error) {
        console.error(
          'Kunne ikke lægge vin i kurven:',
          error
        );

        button.disabled = false;
        button.textContent =
          originalButtonText;

        statusElement.textContent =
          error?.message ||
          'Der opstod en fejl. Prøv igen.';
      }
    };

    const createProductCard = (
      product
    ) => {
      const card =
        document.createElement(
          'article'
        );

      card.className =
        'va-ai__product-card';

      const imageLink =
        document.createElement('a');

      imageLink.className =
        'va-ai__product-image';

      imageLink.href =
        product.url || '#';

      imageLink.setAttribute(
        'aria-label',
        `Se ${product.title || 'vinen'}`
      );

      if (product.image) {
        const image =
          document.createElement('img');

        image.src =
          product.image;

        image.alt =
          product.imageAlt ||
          product.title ||
          'Vin fra Vinarkivet';

        image.loading = 'lazy';
        image.width = 420;
        image.height = 520;

        imageLink.appendChild(image);
      } else {
        const placeholder =
          document.createElement('span');

        placeholder.className =
          'va-ai__product-placeholder';

        placeholder.textContent = 'V';

        imageLink.appendChild(
          placeholder
        );
      }

      const body =
        document.createElement('div');

      body.className =
        'va-ai__product-body';

      const eyebrow =
        document.createElement('div');

      eyebrow.className =
        'va-ai__product-eyebrow';

      eyebrow.textContent =
        product.type ||
        product.vendor ||
        'Udvalgt af sommelieren';

      const title =
        document.createElement('a');

      title.className =
        'va-ai__product-title';

      title.href =
        product.url || '#';

      title.textContent =
        product.title ||
        'Vin fra Vinarkivet';

      const meta =
        document.createElement('div');

      meta.className =
        'va-ai__product-meta';

      if (
        product.variantTitle &&
        product.variantTitle.toLowerCase() !==
          'default title'
      ) {
        meta.textContent =
          product.variantTitle;
      }

      const price =
        document.createElement('div');

      price.className =
        'va-ai__product-price';

      price.textContent =
        product.formattedPrice ||
        [
          product.priceAmount,
          product.currencyCode
        ]
          .filter(Boolean)
          .join(' ');

      const actions =
        document.createElement('div');

      actions.className =
        'va-ai__product-actions';

      const productLink =
        document.createElement('a');

      productLink.className =
        'va-ai__product-link';

      productLink.href =
        product.url || '#';

      productLink.textContent =
        'Se vinen';

      const addButton =
        document.createElement(
          'button'
        );

      addButton.type = 'button';

      addButton.className =
        'va-ai__product-add';

      addButton.textContent =
        'Læg i kurv';

      const status =
        document.createElement('div');

      status.className =
        'va-ai__product-status';

      status.setAttribute(
        'aria-live',
        'polite'
      );

      addButton.addEventListener(
        'click',
        () => {
          addProductToCart(
            product,
            addButton,
            status
          );
        }
      );

      actions.appendChild(
        productLink
      );

      actions.appendChild(
        addButton
      );

      body.appendChild(eyebrow);
      body.appendChild(title);

      if (meta.textContent) {
        body.appendChild(meta);
      }

      body.appendChild(price);
      body.appendChild(actions);
      body.appendChild(status);

      card.appendChild(imageLink);
      card.appendChild(body);

      return card;
    };

    const createProductCards = (
      products
    ) => {
      if (
        !Array.isArray(products) ||
        !products.length
      ) {
        return null;
      }

      const wrapper =
        document.createElement(
          'section'
        );

      wrapper.className =
        'va-ai__products';

      wrapper.setAttribute(
        'aria-label',
        'Vinarkivets anbefalinger'
      );

      const heading =
        document.createElement('h3');

      heading.className =
        'va-ai__products-heading';

      heading.textContent =
        products.length === 1
          ? 'Sommelierens anbefaling'
          : 'Sommelierens anbefalinger';

      const grid =
        document.createElement('div');

      grid.className =
        'va-ai__products-grid';

      products
        .slice(0, 3)
        .forEach((product) => {
          grid.appendChild(
            createProductCard(product)
          );
        });

      wrapper.appendChild(heading);
      wrapper.appendChild(grid);

      messagesContainer.appendChild(
        wrapper
      );

      scrollToBottom();

      return wrapper;
    };

    const requestAIReply = async (
      message,
      signal
    ) => {
      const response = await fetch(
        API_URL,
        {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          signal,

          headers: {
            'Content-Type':
              'application/json'
          },

          body: JSON.stringify({
            message,
            history:
              conversationHistory
          })
        }
      );

      let data;

      try {
        data =
          await response.json();
      } catch (error) {
        throw new Error(
          'Serveren returnerede et ugyldigt svar.'
        );
      }

      if (!response.ok) {
        throw new Error(
          data?.error ||
          'Vinassistenten kunne ikke svare.'
        );
      }

      if (
        typeof data?.reply !==
          'string' ||
        !data.reply.trim()
      ) {
        throw new Error(
          'Vinassistenten returnerede et tomt svar.'
        );
      }

      return {
        reply:
          data.reply.trim(),

        products:
          Array.isArray(
            data.products
          )
            ? data.products
            : [],

        needsMoreInformation:
          data.needsMoreInformation ===
          true
      };
    };

    const handleMessage = async (
      message
    ) => {
      const cleanMessage =
        String(message).trim();

      if (
        !cleanMessage ||
        isReplying
      ) {
        return;
      }

      isReplying = true;

      hideSuggestions();

      createMessage(
        'user',
        cleanMessage
      );

      input.value = '';

      resizeInput();

      if (sendButton) {
        sendButton.disabled = true;
      }

      const typingIndicator =
        createTypingIndicator();

      const controller =
        new AbortController();

      const timeout =
        window.setTimeout(() => {
          controller.abort();
        }, 60000);

      try {
        const result =
          await requestAIReply(
            cleanMessage,
            controller.signal
          );

        typingIndicator.remove();

        createMessage(
          'assistant',
          result.reply
        );

        createProductCards(
          result.products
        );

        conversationHistory.push(
          {
            role: 'user',
            content: cleanMessage
          },
          {
            role: 'assistant',
            content: result.reply
          }
        );

        conversationHistory =
          conversationHistory.slice(
            -12
          );
      } catch (error) {
        typingIndicator.remove();

        let errorMessage =
          'Der opstod en teknisk fejl. Prøv igen om et øjeblik.';

        if (
          error?.name ===
          'AbortError'
        ) {
          errorMessage =
            'Vinassistenten brugte for lang tid på at svare. Prøv igen.';
        } else if (
          error?.message
        ) {
          errorMessage =
            error.message;
        }

        createMessage(
          'assistant',
          errorMessage
        );

        console.error(
          'Vinarkivet AI-fejl:',
          error
        );
      } finally {
        window.clearTimeout(
          timeout
        );

        isReplying = false;

        if (sendButton) {
          sendButton.disabled =
            false;
        }

        input.focus();
      }
    };

    const bindSuggestionButtons = () => {
      const suggestionButtons =
        messagesContainer.querySelectorAll(
          '[data-va-suggestion]'
        );

      suggestionButtons.forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              const message =
                button.dataset
                  .vaSuggestion ||
                button.textContent ||
                '';

              handleMessage(
                message
              );
            }
          );
        }
      );
    };

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();

        handleMessage(
          input.value
        );
      }
    );

    input.addEventListener(
      'input',
      resizeInput
    );

    input.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key ===
            'Enter' &&
          !event.shiftKey
        ) {
          event.preventDefault();

          form.requestSubmit();
        }
      }
    );

    newChatButton?.addEventListener(
      'click',
      () => {
        messagesContainer.innerHTML =
          originalContent;

        conversationHistory = [];
        input.value = '';
        isReplying = false;

        if (sendButton) {
          sendButton.disabled =
            false;
        }

        resizeInput();
        bindSuggestionButtons();
        input.focus();
        scrollToBottom();
      }
    );

    bindSuggestionButtons();
    resizeInput();
  };

  const initAllVinarkivetAISections = (
    scope = document
  ) => {
    if (
      scope.matches?.('.va-ai')
    ) {
      initVinarkivetAI(scope);
    }

    scope
      .querySelectorAll?.(
        '.va-ai'
      )
      .forEach(
        initVinarkivetAI
      );
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllVinarkivetAISections();
      }
    );
  } else {
    initAllVinarkivetAISections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllVinarkivetAISections(
        event.target
      );
    }
  );
})();